module.exports = __webpack_public_path__ + "img/user-1@2x.61fc226.png";